/**
 * Permet de marquer visuellement un élément de formulaire requis
 * usage : 
 * import ButtonDeBase from '../Components/ButtonDeBase.jsx';
 * <MarqueRequis />
 * @component
*/
function MarqueRequis() {
  return (
    <span className="required-inline-etoile" title="Champ obligatoire">*</span>
  );
}

export default MarqueRequis;
